import styled from "styled-components";

export const DialogBody = styled.div`
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  & > * + * {
    margin-top: 0.5rem;
  }
`;
